<template>
  <ul>
    <li v-for="(item, i) in list" :key="i">
      <CouponItem :incoupon="item"></CouponItem>
    </li>
  </ul>
</template>
<script>
import CouponItem from '../item'
export default {
  props: {
    list: Array
  },
  components: {
    CouponItem
  }
}
</script>
<style lang="scss" scoped>
ul {
  li {
    margin-bottom: 0.2rem;
    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
